export interface Regret {
  id: string;
  text: string;
  category_tag: 'love' | 'career' | 'family' | 'money' | 'health' | 'other';
  submitted_at: string;
  likes: number;
}

export interface PaginatedResponse {
  regrets: Regret[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    hasMore: boolean;
  };
}

export interface Stats {
  totalRegrets: number;
}

export interface SubmitResponse {
  id: string;
  clientSecret: string;
  category: string;
}

export type CategoryTag = 'love' | 'career' | 'family' | 'money' | 'health' | 'other';
export type SortOption = 'recent' | 'likes';

export const CATEGORY_COLORS: Record<CategoryTag, string> = {
  love: 'bg-category-love',
  career: 'bg-category-career',
  family: 'bg-category-family',
  money: 'bg-category-money',
  health: 'bg-category-health',
  other: 'bg-category-other',
};

export const CATEGORY_LABELS: Record<CategoryTag, string> = {
  love: 'Love',
  career: 'Career',
  family: 'Family',
  money: 'Money',
  health: 'Health',
  other: 'Other',
};
